export const UPDATE_LOCATION_INFORMATION = 'UPDATE_LOCATION_INFORMATION';
export const UPDATE_LOCATION = 'UPDATE_LOCATION';
export const UPDATE_LOCATION_SUGGESTIONS = 'UPDATE_LOCATION_SUGGESTIONS';
export const SET_WAITING_FOR_LOCATION = 'SET_WAITING_FOR_LOCATION';
export const LOCATION_DENIED = 'LOCATION_DENIED';
